/**
 * Seller identity in one place. Legal pages and Paddle's domain review read
 * from here, so the name never drifts between pages.
 *
 * Placeholders start with TODO_ and are guarded by a unit test that fails
 * while any of them remains, so we cannot publish with a placeholder.
 */
export const SELLER_LEGAL_NAME_AR = "سارة ممدوح النحاس";
export const SELLER_LEGAL_NAME_EN = "Sara Mamdouh Alnahas";
export const SELLER_COUNTRY_EN = "United Arab Emirates";
export const SELLER_COUNTRY_AR = "الإمارات العربية المتحدة";
export const CONTACT_EMAIL = "hi@drsaranahas.com";

export const SELLER_VALUES = {
  SELLER_LEGAL_NAME_AR,
  SELLER_LEGAL_NAME_EN,
  SELLER_COUNTRY_EN,
  SELLER_COUNTRY_AR,
  CONTACT_EMAIL,
} as const;

export function sellerPlaceholders(): string[] {
  return Object.entries(SELLER_VALUES)
    .filter(([, v]) => v.startsWith("TODO_"))
    .map(([k]) => k);
}
